import React from 'react'
import styled from 'styled-components'
import YouTube from 'react-youtube'
import Fade from 'react-reveal/Fade'

const Title = styled.div`
	font-size: 32px;
	text-align: center;
`;

const Section = styled.div`
	padding: 4rem 0 4rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	
	@media (min-width: 800px) {
	    flex-direction: row;
	    padding-right: 1rem;
	    padding-left: 1rem;
	    align-items: flex-start;
	}
`

const VideoWrapper = styled.div`
    position: relative; 
    width: 100%;
    overflow: hidden;
    
    &::after {
        padding-top: 56.25%;
        display: block;
        content: '';
    }
    
    iframe {
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        position: absolute;  
    }
`

const VideoTitle = styled.div`
    margin-bottom: 1rem;
    font-weight: bold;
    color: #000;
    text-align: center;
`

const VideoDescription = styled.div`
`

const VideoCard = styled.div`
    flex: 0 1 33%;
	max-width: 90%;
	margin: 0 auto 2rem;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 15px 30px 0px;
    
    @media (min-width: 800px) {
	    margin: 0 1rem;
	}
`

const VideoDetails = styled.div`
	padding: 1.5rem;
`

const Videos = () => {
    const opts = {
        height: '360',
        width: '640',
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
        }
    }

    return (
        <Fade duration={500} up cascade>
        <Title>- Emotion & Body Code Videos -</Title>
        <Section>
            <VideoCard>
                <VideoWrapper>
                    <YouTube videoId="wo3A3_lkTxE" opts={opts} />
                </VideoWrapper>
                <VideoDetails>
                    <VideoTitle>What is the Emotion Code?</VideoTitle>
                </VideoDetails>
            </VideoCard>

            <VideoCard>
                <VideoWrapper>
                    <YouTube videoId="fq6reWW5usM" opts={opts} />
                </VideoWrapper>
                <VideoDetails>
                    <VideoTitle>What is the Heart Wall?</VideoTitle>
                </VideoDetails>
            </VideoCard>

            <VideoCard>
                <VideoWrapper>
                    <YouTube videoId="4ibz1dYgSaA" opts={opts} />
                </VideoWrapper>
                <VideoDetails>
                    <VideoTitle>What is the Body Code?</VideoTitle>
                </VideoDetails>
            </VideoCard>
        </Section>
        </Fade>

    )
}

export default Videos
